import './Dropdown.scss';

import React, { useContext, useRef } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { get, set } from 'lodash';

import Select from 'react-select';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormLabel from 'react-bootstrap/FormLabel';

import { NCRContext } from 'views';
import { InputLabel } from 'components/form/prototypes'

const Dropdown = ({ name, label, disabled, required, data }) => {

  const { state, setState } = useContext(NCRContext);
  const { control, errors } = useFormContext();

  const stateValue = get(state, name) || '';

  const defaultValue = stateValue ? { value: stateValue?.id, label: stateValue?.name } : null;
  const defaultError = get(errors, name);
  const defaultCallback = (value) => {
    const val = data?.find(item => item.id === value) || {}
    setState(state => ({ ...set(state, name, val) }));
  };

  const selectRef = useRef();

  return (
    <>
      {
        disabled ?
          <InputLabel value={defaultValue?.label} label={label} disabled />
          :
          <Row className={'mb-2'}>
            <Col className={'my-auto'}>
              <FormLabel className={'my-auto'}>{`${label}:`}</FormLabel>
            </Col>
            <Col>
              <Controller
                name={name}
                id={name}
                control={control}
                rules={{ required: required }}
                onFocus={() => selectRef.current.focus()}
                defaultValue={defaultValue}
                render={({ onChange }) => (
                  <Select
                    onChange={event => {
                      defaultCallback(event.value);
                      onChange(event);
                    }}
                    className={(defaultError ? 'error-dropdown ' : '') + name + '-dropdown inner-dropdown '}
                    placeholder='Select'
                    options={data?.map(item => ({ value: item.id, label: item.name }))}
                    defaultValue={defaultValue}
                    ref={ref => (selectRef.current = ref)}
                    styles={{ menu: provided => ({ ...provided, zIndex: 5 }) }}
                  />
                )}
              />
            </Col>
          </Row>
      }
    </ >
  )
}

export { Dropdown };
